import React, { Component } from "react";
import * as BABYLON from '@babylonjs/core';
import ParameterErrors from '../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
class BabylonCameraPan {
	constructor(params){
		const {babylonScene, inertiaDecayFactor, inertiaNegligibleThreshold}=params||{};
		if(!babylonScene)throwNotProvided('babylonScene');
		this._inertiaDecayFactor = inertiaDecayFactor===undefined?0.9:inertiaDecayFactor;
		this._inertiaNegligibleThreshold = inertiaNegligibleThreshold===undefined?0.5:inertiaNegligibleThreshold;
		this._babylonScene = babylonScene;
		this._isNewForwardVectorTooCloseToSingularity= this._isNewForwardVectorTooCloseToSingularity.bind(this);
		this._pan= this._pan.bind(this);
		this._sphericalPan= this._sphericalPan.bind(this);
		this._inertialPan= this._inertialPan.bind(this);
		this._getPointerViewSpaceDirectionToRef= this._getPointerViewSpaceDirectionToRef.bind(this);
		this._mouseLeft = this._mouseLeft.bind(this);
		this._onPointerUp= this._onPointerUp.bind(this);
		this._onPointerDown= this._onPointerDown.bind(this);
		this._setMouseButtonStates = this._setMouseButtonStates.bind(this);
		this._stopPanningIfPanning = this._stopPanningIfPanning.bind(this);
		
		babylonScene.scene.defaultCursor = "grab";

		babylonScene.camera.rotationQuaternion = BABYLON.Quaternion.Identity();
		
		this._leftButtonDown=false;
		this._rightButtonDown=false;
		this._ptrX = 0;
		this._ptrY = 0;
		this._inertiaX = 0;
		this._inertiaY = 0;

		this._priorDir = new BABYLON.Vector3();
		this._currentDir = new BABYLON.Vector3();
		this._rotationAxis = new BABYLON.Vector3();
		this._rotationAngle = 0;
		this._rotation = new BABYLON.Quaternion();
		this._newForward = new BABYLON.Vector3();
		this._newRight = new BABYLON.Vector3();
		this._newUp = new BABYLON.Vector3();
		this._matrix = new BABYLON.Matrix.Identity();
		
		this._inertialPanObserver = null;
		this._sphericalPanObserver = null;
		this._leftButtonDown = false;
		babylonScene.scene.onPointerDown = this._onPointerDown;
		babylonScene.scene.onPointerUp = this._onPointerUp;
		document.addEventListener("mouseleave", this._mouseLeft);
	}
	_setMouseButtonStates(e) {
		const isLeftButton = e.button===0||e.which===1;
		const isRightButton = e.button===2||e.which===3;
		switch(e.type){
			case 'pointerdown':
				if(isLeftButton) this._leftButtonDown=true;
				else if(isRightButton)this._rightButtonDown=true;
				break;
			case 'pointerup':
				if(isLeftButton) this._leftButtonDown=false;
				else if(isRightButton)this._rightButtonDown=false;
				break;
			case 'mouseleave':
				this._leftButtonDown=false;
				this._rightButtonDown=false;
				break;
			
		}
	}
	_isNewForwardVectorTooCloseToSingularity(v){
			const TOO_CLOSE_TO_UP_THRESHOLD = 0.99;
			return Math.abs(BABYLON.Vector3.Dot(v, BABYLON.Vector3.Up())) > TOO_CLOSE_TO_UP_THRESHOLD;
	}
	_mouseLeft(e){
		this._setMouseButtonStates(e);
		this._stopPanningIfPanning();
	}
	_stopPanningIfPanning(e){
		if(!this._currentlyPanning)return;
		this._currentlyPanning = false;
		this._babylonScene.scene.defaultCursor = "grab";
		this._babylonScene.scene.onBeforeRenderObservable.remove(this._sphericalPanObserver);
		this._inertialPanObserver = this._babylonScene.scene.onBeforeRenderObservable.add(this._inertialPan);
	}
	_pan(currX, currY) {
		var computeNewForward = (x, y) => {
			this._getPointerViewSpaceDirectionToRef(this._ptrX, this._ptrY, this._priorDir);
			this._getPointerViewSpaceDirectionToRef(x, y, this._currentDir);

			BABYLON.Vector3.CrossToRef(this._priorDir, this._currentDir, this._rotationAxis);

			if (this._rotationAxis.lengthSquared() > 0) {
				this._rotationAngle = BABYLON.Vector3.GetAngleBetweenVectors(this._priorDir, this._currentDir, this._rotationAxis);
				BABYLON.Quaternion.RotationAxisToRef(this._rotationAxis, -this._rotationAngle, this._rotation);

				this._newForward.set(0, 0, 1);
				this._newForward.rotateByQuaternionToRef(this._rotation, this._newForward);
				this._newForward.rotateByQuaternionToRef(this._babylonScene.camera.rotationQuaternion, this._newForward);
				return !this._isNewForwardVectorTooCloseToSingularity(this._newForward);
			}
			return false;
		}

		if (computeNewForward(currX, currY) || computeNewForward(currX, this._ptrY)) {
			BABYLON.Vector3.CrossToRef(BABYLON.Vector3.Up(), this._newForward, this._newRight);
			BABYLON.Vector3.CrossToRef(this._newForward, this._newRight, this._newUp);
			this._matrix.setRowFromFloats(0, this._newRight.x, this._newRight.y, this._newRight.z, 0);
			this._matrix.setRowFromFloats(1, this._newUp.x, this._newUp.y, this._newUp.z, 0);
			this._matrix.setRowFromFloats(2, this._newForward.x, this._newForward.y, this._newForward.z, 0);
			this._babylonScene.fromRotationMatrixToRef(this._matrix.getRotationMatrix());
		}
	}
	
	_sphericalPan(){
		this._pan(this._babylonScene.scene.pointerX, this._babylonScene.scene.pointerY);
		this._inertiaX = this._babylonScene.scene.pointerX - this._ptrX;
		this._inertiaY = this._babylonScene.scene.pointerY - this._ptrY;
		this._ptrX = this._babylonScene.scene.pointerX;
		this._ptrY = this._babylonScene.scene.pointerY;
	}
	 _inertialPan(){
		if (Math.abs(this._inertiaX) > this._inertiaNegligibleThreshold || Math.abs(this._inertiaY) > this._inertiaNegligibleThreshold) {
			this._pan(this._ptrX + this._inertiaX, this._ptrY + this._inertiaY);
			this._pan(this._ptrX + this._inertiaX, this._ptrY + this._inertiaY);

			this._inertiaX *= this._inertiaDecayFactor;
			this._inertiaY *= this._inertiaDecayFactor;
		}
		else {
			this._babylonScene.scene.onBeforeRenderObservable.remove(this._inertialPanObserver);
		}
	}
	_onPointerDown(e){
		this._setMouseButtonStates(e);
		if(!this._leftButtonDown||this._rightButtonDown)return;
		if(this._currentlyPanning)return;
		this._currentlyPanning = true;
		this._babylonScene.scene.onBeforeRenderObservable.remove(this._inertialPanObserver);
		this._babylonScene.scene.defaultCursor = "grabbing";
		this._ptrX = this._babylonScene.scene.pointerX;
		this._ptrY = this._babylonScene.scene.pointerY;
		this._sphericalPanObserver = this._babylonScene.scene.onBeforeRenderObservable.add(this._sphericalPan);
	}
	_onPointerUp(e){
		this._setMouseButtonStates(e);
		this._stopPanningIfPanning();
	}
	_getPointerViewSpaceDirectionToRef(x, y, ref){
		BABYLON.Vector3.UnprojectToRef(
			new BABYLON.Vector3(x, y, 0), 
			this._babylonScene.canvas.width, 
			this._babylonScene.canvas.height,
			BABYLON.Matrix.Identity(),
			BABYLON.Matrix.Identity(), 
			this._babylonScene.camera.getProjectionMatrix(),
			ref);
		ref.normalize();
	}
}
export default BabylonCameraPan;